import { BASE_URL } from '../utils/apiUtils';

import { HttpService } from './HttpService';

const CodeMaintenanceService = (isGlobalAdmin = false) => {
	const {
		get,
		post,
		put,
		deleteFn,
		deleteWithBody,
		patch,
		postWithoutClerk,
		putWithoutClerk,
		getWithoutClerk
	} = HttpService();

	const baseUrl = BASE_URL
		? BASE_URL + '/api/code-table-management'
		: 'http://localhost:8081/api/code-table-management';

	const getCodeTypeByName = (codeType) => {
		return get(
			`${BASE_URL}/api/code-table-management/code-type/${codeType}`,
			'getCodeTypeByName',
			{}
		);
	};

	/** Code Table */
	const getCodeTable = async ({ codeCategoryId, codeTypeId }) => {
		let url = `${baseUrl}/codes?codeCategoryId=${codeCategoryId}&codeTypeId=${codeTypeId}`;

		let obj_code = await getCodeTypeByName('case_type');

		const isDropdownCaseCategory =
			codeCategoryId === obj_code.data.codeCategoryId && codeTypeId === obj_code.data.codeTypeId;

		if (isDropdownCaseCategory) {
			url = `${baseUrl}/code-tables/case_category/id-description`;
		}

		return isGlobalAdmin && isDropdownCaseCategory
			? getWithoutClerk(url, getCodeTable, {})
			: isDropdownCaseCategory
			? get(url, 'getCodeTable', {})
			: get(url, 'getCodeTable', {});
	};

	const postCodeTable = ({ body, codeCategoryId, codeTypeId }) => {
		const url = `${baseUrl}/codes?codeCategoryId=${codeCategoryId}&codeTypeId=${codeTypeId}`;
		return post(url, body, 'postCodeTable', {});
	};

	const postCodeTableWithNoClerk = ({ body, codeCategoryId, codeTypeId }) => {
		const url = `${baseUrl}/codes?codeCategoryId=${codeCategoryId}&codeTypeId=${codeTypeId}`;
		return postWithoutClerk(url, body, 'postCodeTable', {});
	};

	const updateCodeTable = ({ body, codeCategoryId, codeTypeId }) => {
		const url = `${baseUrl}/codes?codeCategoryId=${codeCategoryId}&codeTypeId=${codeTypeId}`;

		return isGlobalAdmin
			? putWithoutClerk(url, body, 'putCodeTable', {})
			: put(url, body, 'putCodeTable', {});
	};

	/** Code Category */
	const postCodeCategory = (body) => {
		const url = `${BASE_URL}/api/code-table-management/code-categories`;
		return post(url, body, 'postCodeCategory', {});
	};

	const getCodeCategory = ({ active = false }) => {
		const url = `${baseUrl}/code-categories${active ? '?active=true' : ''}`;
		return get(url, 'GetCodeCategory', {});
	};

	/** Code Type */
	const postCodeType = (body) => {
		const url = `${BASE_URL}/api/code-table-management/code-types`;
		return post(url, body, 'postCodeCategory', {});
	};

	const getCodeType = ({ active = false, codeCategoryId = 1 }) => {
		const url = `${baseUrl}/code-types?active=${active}${
			codeCategoryId ? `&codeCategoryId=${codeCategoryId}` : ''
		}`;
		return get(url, 'GetCodeType', {});
	};

	/** Case Number Format **/
	const getCaseNoFormats = async (page, size) => {
		const url = `${BASE_URL}/api/case-no-format-management/case-no-formats?page=${page}&size=${size}`;
		return get(url, 'getCaseNoFormats', {});
	};

	const getCaseNoFormatLinkedCaseTypes = async (caseNoFormatId) => {
		const url = `${BASE_URL}/api/case-no-format-management/${caseNoFormatId}/linked-case-types`;
		return get(url, 'getCaseNoFormatLinkedCaseTypes', {});
	};

	const softDeleteCaseNoFormatLinkedCaseTypes = (caseNoFormatId) => {
		const url = `${BASE_URL}/api/case-no-format-management/case-no-formats/${caseNoFormatId}`;
		return deleteFn(url, 'deleteSoftCaseNoFormatLinkedCaseTypes', {});
	};

	const getCodeTableByCodeCategory = async (category) => {
		const url = `${baseUrl}/code-tables/categories/${category}`;
		return get(url, 'getCodeTableByCodeCategory', {});
	};

	const postCaseNoFormat = (body) => {
		const url = `${BASE_URL}/api/case-no-format-management/case-no-formats`;
		return post(url, body, 'postCaseNoFormat', {});
	};

	const putCaseNoFormat = (body, id) => {
		const url = `${BASE_URL}/api/case-no-format-management/case-no-formats/${id}`;
		return put(url, body, 'putCaseNoFormat', {});
	};

	const getCaseNoFormat = (active = false) => {
		const url = `${baseUrl}/case-no-format-management/case-no-formats/${
			active ? '?active=true' : ''
		}`;
		return get(url, 'GetCaseNoFormat', {});
	};

	const getCaseNoFormatHistory = (id, page, size) => {
		const url = `${baseUrl}/case-no-format-management/${id}/history?page=${page}&size=${size}`;
		return get(url, 'getCaseNoFormatHistory', {});
	};

	const unlinkCaseNoFormatCaseType = (id) => {
		const url = `${BASE_URL}/api/case-no-format-management/case-no-format-case-types/unlink-types/${id}`;
		return deleteFn(url, 'unlinkCaseNoFormatCaseType', {});
	};

	/** Case Type Category code */
	const getIndividualCaseTypeCategory = (code) => {
		const url = `${BASE_URL}/api/case-type-category-code-management/case-type-category-codes/${code}`;
		return get(url, 'getIndividualCaseTypeCategory', {});
	};
	const getAllCaseTypeCategory = (code) => {
		const url = `${BASE_URL}/api/case-type-category-code-management/${code}/case-type-category-codes`;
		return get(url, 'getAllCaseTypeCategory', {});
	};

	/** Disposition Code */
	const getDispositionCode = (code) => {
		const url = `${BASE_URL}/api/disposition-code-management/disposition-codes/${code}`;
		return get(url, 'getDispositionCode', {});
	};

	const getDispositionCodeByDispositionCategoryId = (dispositionCategoryId) => {
		const url = `${BASE_URL}/api/disposition-code-management/disposition-category-code/${dispositionCategoryId}/disposition-codes`;
		return get(url, 'getDispositionCodeByDispositionCategoryId', {});
	};

	/** EVENT MAINTENANCE */

	/** Link case category */
	const linkCaseCategory = (body) => {
		const url = `${BASE_URL}/api/event-case-category-management/event-case-category`;
		return post(url, body, 'linkCaseCategory', {});
	};

	/** Create New Event Action */
	const newEventAction = (body) => {
		const url = `${BASE_URL}/api/event-action-management/event-action`;
		return post(url, body, 'newEventAction', {});
	};

	/**Delete Event Action */
	const deactivateEventAction = (eventActionId, isActive) => {
		const url = `${BASE_URL}/api/event-action-management/${eventActionId}?is-active=${isActive}`;
		return patch(url, 'deactivateEventAction', {});
	};

	// Add User for Notifications

	const newUserNotification = (body) => {
		const url = `${BASE_URL}/api/code-change-notification`;
		return post(url, body, 'newUserNotification', {});
	};

	// Remove Users from Notifications
	const deleteUserNotification = (body) => {
		const url = `${BASE_URL}/api/code-change-notification`;
		return deleteWithBody(url, body, 'deleteUserNotification', {});
	};

	// Disposition Type Data

	const getDispositionTypeData = () => {
		const url = `${BASE_URL}/api/code-table-management/codes?codeCategoryId=2&codeTypeId=70`;
		return get(url, 'getDispositionTypeData', {});
	};

	// GET Transaction Types

	const getTransactionTypes = (code) => {
		const url = `${BASE_URL}/api/financial-till-management/financial-till/${code}`;
		return get(url, 'getTransactionTypes', {});
	};

	// GET Fin Till Users

	const getFinTillUsers = (code) => {
		const url = `${BASE_URL}/api/financial-till-management/financial-till/${code}`;
		return get(url, 'getFinTillUsers', {});
	};

	// GET Users

	const getAllUsers = () => {
		const url = `${BASE_URL}/api/code-change-notification?page=0&size=500`;
		return get(url, 'getAllUsers', {});
	};

	const getAllUsersData = () => {
		const url = `${BASE_URL}/api/user-management/users/groups?page=0&size=500`;
		return get(url, 'getAllUsersData', {});
	};

	const getCodeStatus = (code, codeTypeId) => {
		const url = `${baseUrl}/code-tables/${code}/code-type/${codeTypeId}`;
		return get(url, 'getCodeStatus', {});
	};

	const getDrawerNumberStatus = (drawerNumber) => {
		const url = `${BASE_URL}/api/financial-till-management/financial-till/code/${drawerNumber}`;
		return get(url, 'getDrawerNumberStatus', {});
	};

	const getLinkedCaseCategories = () => {
		const url = `${BASE_URL}/api/code-table-management/code-type/66/code-tables?page=0&size=10`;
		return get(url, 'getLinkedCaseCategories', {});
	};

	const getSelectedLinkedCaseCategories = (codeTableId) => {
		const url = `${BASE_URL}/api/event-code-management/event-code/${codeTableId}`;
		return get(url, 'getSelectedLinkedCaseCategories', {});
	};
	const getEventActionTypes = (eventCodeId) => {
		const url = `${BASE_URL}/api/event-action-management/event-code-id/${eventCodeId}/event-actions`;
		return get(url, 'getEventActionTypes', {});
	};

	const getPartyTypeCode = (code) => {
		const url = `${BASE_URL}/api/party-code-management/party-code/${code}`;
		return get(url, 'getPartyTypeCode', {});
	};

	const getExistingCodeName = (codeName) => {
		const url = `${BASE_URL}/api/disposition-code-management/disposition-codes/${codeName}`;
		return get(url, 'getExistingCodeName', {});
	};

	const checkIfJurisdictionAdmin = () => {
		const url = `${BASE_URL}/api/code-table-management/is-jurisdiction-admin`;
		return get(url, 'checkIfJurisdictionAdmin', {});
	};

	const getAllCode = (category, subCategory, pageSize, pageno, isClerkId) => {
		const url = pageSize
			? `${BASE_URL}/api/code-table-management/codes?codeCategoryId=${category}&codeTypeId=${subCategory}&page=${pageno}&size=${pageSize}`
			: `${BASE_URL}/api/code-table-management/codes?codeCategoryId=${category}&codeTypeId=${subCategory}`;
		return get(url, 'getAllCode', {}, !isClerkId);
	};

	const getCurrencyCodes = () => {
		const url = `${BASE_URL}/api/code-table-management/code-tables/categories/currency`;
		return get(url, 'getCurrencyCodes', {});
	};

	const patchActivateInactivateToEventCode = (codeTypeId, activateFlag) => {
		const url = `${BASE_URL}/api/event-types/${codeTypeId}?is-active=${activateFlag}`;
		return patch(url, 'patchActivateInactivateToEventCode', {});
	};

	const getTabs = () => {
		return {
			table: 'code_table',
			code: 'code',
			fields: [
				{
					codeTableId: '2191',
					codeTypeId: '66',
					codeCategory: 'case_category',
					code: 'C',
					description: 'Related to Criminal Matters',
					activeDate: '1901-04-20 04:16:48.0',
					inactiveDate: 'null',
					reasonForModification: 'null',
					hasModifications: 'true'
				},
				{
					codeTableId: '2192',
					codeTypeId: '66',
					codeCategory: 'case_category',
					code: 'V',
					description: 'Civil',
					activeDate: '1901-04-20 06:59:55.0',
					inactiveDate: 'null',
					reasonForModification: 'null',
					hasModifications: 'false'
				},
				{
					codeTableId: '2193',
					codeTypeId: '66',
					codeCategory: 'case_category',
					code: 'P',
					description: 'Probate',
					activeDate: '2022-04-21 05:00:00.0',
					inactiveDate: 'null',
					reasonForModification: 'null',
					hasModifications: 'false'
				},
				{
					codeTableId: '2194',
					codeTypeId: '66',
					codeCategory: 'case_category',
					code: 'F',
					description: 'Family',
					activeDate: '2022-04-21 05:00:00.0',
					inactiveDate: 'null',
					reasonForModification: 'null',
					hasModifications: 'false'
				},
				{
					codeTableId: '6546',
					codeTypeId: '66',
					codeCategory: 'case_category',
					code: 'J',
					description: 'Juvenile',
					activeDate: '2022-05-03 03:00:00.0',
					inactiveDate: '2030-07-01 03:00:00.0',
					reasonForModification: 'null',
					hasModifications: 'true'
				}
			],
			totalElements: 5,
			totalPages: 1,
			first: true,
			last: true,
			next: false,
			previous: false
		};
	};

	const getOcaColumns = () => {
		const url = `${BASE_URL}/api/oca-management/code-columns?page=0&size=100`;
		return get(url, 'getOcaColumns', {});
	};

	const getFeeGroups = (categoryCode) => {
		const url = `${BASE_URL}/api/fee-group-code-management/group-codes/category/${categoryCode}?page=0&size=100`;
		return get(url, 'getFeeGroups', {});
	};

	const getFeeFineDataForFeeType = (code) => {
		const url = `${BASE_URL}/api/fee-code/codes`;
		return get(url, 'getFeeFineDataForFeeType');
	};
	const getFeeFineDataForFeeGroup = (code) => {
		const url = `${BASE_URL}/api/fee-group-code-management/group-codes?page=0&size=10000`;
		return get(url, 'getFeeFineDataForFeeGroup');
	};

	const deleteEventCaseCategory = (id) => {
		const url = `${BASE_URL}/api/event-case-category-management/event-case-category/${id}`;
		return deleteFn(url, 'deleteEventCaseCategory', {});
	};

	const getCountryCodes = async () => {
		try {
			const objCode = await getCodeTypeByName('country');
			const { data } = objCode;

			const url = `${baseUrl}/codes?page=0&size=10000&codeCategoryId=${data.codeCategoryId}&codeTypeId=${data.codeTypeId}`;
			return get(url, 'getCountryCodes', {});
		} catch (error) {
			console.error(error);
		}

		return null;
	};

	const getCaseCategories = async () => {
		try {
			const objCode = await getCodeTypeByName('case_category');
			const { data } = objCode;

			const url = `${baseUrl}/codes?codeCategoryId=${data.codeCategoryId}&codeTypeId=2&page=0&size=10000`;
			return get(url, 'getCaseCategories', {});
		} catch (error) {
			console.error(error);
		}
	};
	const getCodesByCategories = () => {
		const url = `${BASE_URL}/api/code-table-management/codes?codeCategoryId=2&codeTypeId=6&page=0&size=1000`;
		return get(url, 'getCodesByCategories', {});
	};
	
	const getTermTypes = (page = 0, size = 50) => {
		const url = `${BASE_URL}/api/term-type-code?page=${page}&size=${size}`;
		return get(url, 'getTermTypes', {});
	};

	const getActiveTermTypes = (page = 0, size = 50) => {
		const url = `${BASE_URL}/api/term-type-code/active?page=${page}&size=${size}`;
		return get(url, 'getActiveTermTypes', {});
	};

	const postTermType = (body) => {
		const url = `${BASE_URL}/api/term-type-code`;
		return post(url, body, 'postTermType', {});
	};

	const putTermType = (body, termTypeId) => {
		const url = `${BASE_URL}/api/term-type-code/${termTypeId}`;
		return put(url, body, 'putTermType', {});
	};

	return {
		getDispositionTypeData,
		getCodeTable,
		getCaseNoFormatHistory,
		getCaseNoFormat,
		getCodeCategory,
		getCodeTypeByName,
		getCodeType,
		getIndividualCaseTypeCategory,
		getDispositionCode,
		getDispositionCodeByDispositionCategoryId,
		getAllCaseTypeCategory,
		getCodeTableByCodeCategory,
		getCaseNoFormats,
		getCaseNoFormatLinkedCaseTypes,
		unlinkCaseNoFormatCaseType,
		postCodeTable,
		postCodeCategory,
		postCodeType,
		postCaseNoFormat,
		updateCodeTable,
		linkCaseCategory,
		newEventAction,
		putCaseNoFormat,
		getTransactionTypes,
		newUserNotification,
		getAllUsers,
		getTabs,
		softDeleteCaseNoFormatLinkedCaseTypes,
		getCodeStatus,
		deleteUserNotification,
		getFinTillUsers,
		getAllUsersData,
		getOcaColumns,
		getFeeGroups,
		getDrawerNumberStatus,
		getLinkedCaseCategories,
		getSelectedLinkedCaseCategories,
		getFeeFineDataForFeeType,
		getFeeFineDataForFeeGroup,
		deactivateEventAction,
		getEventActionTypes,
		getExistingCodeName,
		getPartyTypeCode,
		checkIfJurisdictionAdmin,
		getAllCode,
		patchActivateInactivateToEventCode,
		deleteEventCaseCategory,
		postCodeTableWithNoClerk,
		getCountryCodes,
		getCaseCategories,
		getCurrencyCodes,
		getCodesByCategories,
		getTermTypes,
		getActiveTermTypes,
		postTermType,
		putTermType
	};
};

export default CodeMaintenanceService;
